import { Maybe } from 'ballerina-core'
import i18next from 'i18next'
import { SiteBanner } from './siteBanner.state'

export const getSiteBanner = async (): Promise<Maybe<SiteBanner>> => {
  const res = await fetch(`/api/site-banner?locale=${i18next.language}`)
  try {
    const json: SiteBannerResponse = await res.json()
    return { content: json.content, closed: false }
  } catch (e) {
    return undefined
  }
}

type SiteBannerResponse = { content: string; locale: string }
